import BaseComponent from '@/components/base';
import { ButtonStyles } from '@/components/style';
import { style } from './style';
import JSON5 from 'json5';

export default class PlanSelector extends BaseComponent {
  static EXCLUDE_FREQUENCIES = [6, 1];
  static DEFAULT_FREQUENCY = 2;
  onConstruct() {
    this.setPrice();
    this.setSubscriptionPrice();
    this.setSelectOptions();
    this.setOriginalPrice();
  }
  render() {
    return `
      ${ButtonStyles}
      ${style}
    <div class="payment-options-container">
        <div class="toggle-button-title">Purchase options</div>
        <div class="payment-option-wrapper">
            <div class="payment-option">
                <div class="input-container">
                    <div id="radioSubscibe" class="labelCheck">Subscribe </div>
                    <input id="radio1" type="radio" name="planOption" value="subscribe" checked>
                    <label for="radio1" class="radio-style"></label>

                </div>
                ${
                  this.originalPrice === this.totalSubscriptionPrice
                    ? this.totalSubscriptionPriceFormatted
                    : `<div class="price-container">
                    <span class="price-through">
                    ${this.originalPriceFormatted}
                    </span>
                    ${this.totalSubscriptionPriceFormatted}
                    </div>`
                }
            </div>
            <label class="selling-plans-dropdown">
                <select id=selling-plan class="selling-plans-select">
                    ${this.selectOptionsHtml()}
                </select>
            </label>
            <div class="payment-option unselected-input">
                <div class="input-container">
                    <div id="radioOneTime" class="labelCheck"> One-Time Purchase</div>
                    <input id="radio2" type="radio" name="planOption" value="one-time">

                    <label for="radio2" class="radio-style"></label>
                </div>
                ${
                  this.originalPrice === this.totalPrice
                    ? this.totalPriceFormatted
                    : `<div class="price-container">
                    <span class="price-through">
                    ${this.originalPriceFormatted}
                    </span>
                    ${this.totalPriceFormatted}
                    </div>`
                }
            </div>
        </div>
    </div>`;
  }

  afterMount() {
    const inputs = this.shadowRoot.querySelectorAll('input');
    const labels = this.shadowRoot.querySelectorAll('.labelCheck');

    const handleCheck = () => {
      const inputChecked = this.shadowRoot.querySelector('input:checked');
      const inputUnchecked = this.shadowRoot.querySelector(
        'input:not(:checked)'
      );
      const checkedContainer = inputChecked.parentElement.parentElement;
      const uncheckedContainer = inputUnchecked.parentElement.parentElement;
      checkedContainer.classList.remove('unselected-input');
      uncheckedContainer.classList.add('unselected-input');
      const miniQuizBasicComponent = document.querySelector(
        'mini-quiz-basic-component'
      );
      const shopPayShopifyPaymentTerm =
        miniQuizBasicComponent.shadowRoot.querySelector(
          'shopify-payment-terms'
        );
      if (shopPayShopifyPaymentTerm) {
        const boldElement =
          shopPayShopifyPaymentTerm.shadowRoot.querySelector('p .font-bold');
        const isSubscribe = checkedContainer.querySelector('.price-container');
        if (isSubscribe) {
          boldElement.innerHTML = this.totalSubscriptionPriceFormatted;
        } else {
          boldElement.innerHTML = this.totalPriceFormatted;
        }
      }
    };

    inputs.forEach((input, index) => {
      input.addEventListener('click', handleCheck);
    });

    labels.forEach((x) => {
      x.addEventListener('click', () => {
        const input = x.parentElement.querySelector('input');
        input.checked = true;
        handleCheck();
      });
    });
  }

  setOriginalPrice() {
    const products = this.products;

    let originalPrice = 0;

    if (products.length > 0) {
      products.map((element) => {
        return (originalPrice +=
          element.variants[0].price * (element.quantity || 1));
      });
    }
    this.originalPrice = originalPrice;
  }

  setPrice() {
    const products = this.products;
    let totalPrice = 0;

    if (products.length > 0) {
      products.map((element) => {
        return (totalPrice +=
          element.variants[0].price * (element.quantity || 1));
      });
    }

    const discountValue = this.discountMetafield;
    if (discountValue) {
      const discountAmount = totalPrice * (discountValue / 100);
      this.totalPrice = totalPrice - discountAmount;
    } else {
      this.totalPrice = totalPrice;
    }
  }

  setSubscriptionPrice() {
    const products = this.products;
    let totalSubscriptionPrice = 0;

    if (products.length > 0) {
      products.map((element) => {
        return (totalSubscriptionPrice +=
          element.variants[0].price * (element.quantity || 1));
      });
    }

    const discountValue = this.discountSubscriptionMetafield;
    if (discountValue) {
      const discountAmount = totalSubscriptionPrice * (discountValue / 100);
      this.totalSubscriptionPrice = totalSubscriptionPrice - discountAmount;
    } else {
      this.totalSubscriptionPrice = totalSubscriptionPrice;
    }
  }

  setSelectOptions() {
    console.log('proooodddc', this.products);
    const firstProduct = this.products[0];
    const sellingPlansOptions =
      firstProduct.selling_plan_groups[0].selling_plans;

    this.selectOptions = sellingPlansOptions.filter((plan) => {
      if (this.months.length > 0) {
        const isValid = this.months.find(
          (i) => plan?.options[0].value === `${i} Month(s)`
        );

        return isValid;
      }

      const shouldExclude = PlanSelector.EXCLUDE_FREQUENCIES.some(
        (frequency) => {
          return plan?.options[0].value === `${frequency} Month(s)`;
        }
      );
      return !shouldExclude;
    });
  }

  selectOptionsHtml() {
    let optionsHtml = '';
    this.selectOptions?.map((option, index) => {
      const isDefault = !!option?.name?.includes(
        `${PlanSelector.DEFAULT_FREQUENCY}`
      );
      optionsHtml =
        optionsHtml +
        `<option id="${option.id}" value="${index}" ${
          isDefault ? 'selected' : ''
        }>${option.name}</option>`;
    });
    return optionsHtml;
  }

  get months() {
    return JSON.parse(this.getAttribute('months') || '[]');
  }

  get selectedOption() {
    return this.shadowRoot.querySelector('input[name="planOption"]:checked');
  }

  get selectedSellingPlan() {
    return this.shadowRoot.querySelector('#selling-plan');
  }

  get price() {
    return Number(this.getAttribute('price'));
  }

  get originalPriceFormatted() {
    return window.Shopify.formatMoney(
      this.originalPrice,
      window.theme.moneyFormat
    );
  }

  get totalPriceFormatted() {
    return window.Shopify.formatMoney(
      this.totalPrice,
      window.theme.moneyFormat
    );
  }

  get totalSubscriptionPriceFormatted() {
    return window.Shopify.formatMoney(
      this.totalSubscriptionPrice,
      window.theme.moneyFormat
    );
  }

  get discountMetafield() {
    const miniQuizBasicComponent = document.querySelector(
      'mini-quiz-basic-component'
    );
    if (!miniQuizBasicComponent) return null;

    const discountMeta = miniQuizBasicComponent.querySelector(
      'data[name="discountMetafield"]'
    );
    return discountMeta ? Number(discountMeta.innerHTML) : null;
  }

  get discountSubscriptionMetafield() {
    const miniQuizBasicComponent = document.querySelector(
      'mini-quiz-basic-component'
    );
    if (!miniQuizBasicComponent) return null;

    const discountMeta = miniQuizBasicComponent.querySelector(
      'data[name="discountSubscriptionMetafield"]'
    );
    return discountMeta ? Number(discountMeta.innerHTML) : null;
  }

  get products() {
    return this.data.products.value;
  }
}
